import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from '@/pages/home/components/HeroSection';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import FeaturedMatches from '@/pages/home/components/FeaturedMatches';
import LatestNews from '@/pages/home/components/LatestNews';
import StatsSection from '@/pages/home/components/StatsSection';
import FAQSection from '@/pages/home/components/FAQSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'bb体育 - 官方体育平台',
  url: 'https://www.bbsports.com',
  description: 'bb体育是您值得信赖的在线体育平台，提供丰富的体育赛事资讯、赛事直播、体育竞技分析及相关服务。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.bbsports.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="bb体育 - 官方体育平台 | 赛事资讯、直播与竞技分析"
        description="bb体育是您值得信赖的在线体育平台，提供丰富的体育赛事资讯、赛事直播、体育竞技分析及相关服务。bb体育致力于为广大体育爱好者带来极致的体育娱乐体验，立即加入bb体育，感受全方位体育世界。"
        keywords="bb体育,bb体育官网,bb体育平台,bb体育赛事,bb体育直播,bb体育登录,bb体育注册"
        canonicalUrl="https://www.bbsports.com"
        schema={homeSchema}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedMatches />
        <LatestNews />
        <StatsSection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}